import { Component, OnInit, Input } from '@angular/core';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';
@Component({
  selector: 'app-manager-recommendation',
  templateUrl: './manager-recommendation.component.pug',
  styleUrls: ['./manager-recommendation.component.scss'],
  standalone: false
})
export class ManagerRecommendationComponent implements OnInit {
  @Input() data: any;
  constructor(    private permission: PermissionsService) { }

  ngOnInit(): void {
  }

}
